import { useModal } from '@/storybook/modal/useModal';
import { storeToRefs } from 'pinia';
import TemplatesModal from '@/modules/viewer/components/templates/TemplatesModal.vue';
import { useViewerTrack, TrackEvents } from './useViewerTrack';
import { useOrganizationStore } from '@/store/useOrganizationStore';

// Store the modal close function to allow closing from other composables
let templatesModalClose: (() => void) | null = null;

export const useTemplatesModal = () => {
  const { trackItemOwner } = useViewerTrack();
  const { free: isFreeOrganization } = storeToRefs(useOrganizationStore());

  const showTemplatesModal = () => {
    const { open, close } = useModal(TemplatesModal, {
      modalProps: {
        isFree: isFreeOrganization?.value ?? false,
      },
      layoutProps: {
        onOpened: () => {
          trackItemOwner(TrackEvents.VIEWER_TEMPLATES_MODAL_VIEWED);
        },
      },
    });

    // Store close function for external access
    templatesModalClose = close;

    return open();
  };

  const closeTemplatesModal = () => {
    if (templatesModalClose) {
      templatesModalClose();
      templatesModalClose = null;
    }
  };

  return {
    showTemplatesModal,
    closeTemplatesModal,
  };
};

// Export function to close from other modules
export const closeTemplatesModal = () => {
  if (templatesModalClose) {
    templatesModalClose();
    templatesModalClose = null;
  }
};
